import ListFetcherLazy from "../list-fetcher-lazy";
import { useListContext } from "../list.context";

import ListFetcherClassic from "./list-fetcher.component";

const ListFetcherWrapper = () => {
  const { endpoint, lazy } = useListContext();

  // Make sure to render fetchers when List Context values are ready
  if (!endpoint) return null;

  if (lazy) return <ListFetcherLazy />;

  return <ListFetcherClassic />;
};

export default ListFetcherWrapper;
